import { fetchMarketReference } from '../../../services/marketReferenceService';
import { privateCircleService } from '../../../services/privateCircleService';
import type { UserProfileFormData } from './marketProfileStore';
import {
  buildPositionPrefillSource,
  finalizePositionFormForSubmit,
  normalizePositionFormData,
  prefillPositionFromProfileSource,
  type PositionFormData,
} from './positionFormModel';

/** Подмешивает сектор/компанию/роль/индустрию из профиля и заявки при отправке анкеты компенсации (не показываем пользователю). */
export async function submitPositionWithProfileContext(
  form: PositionFormData,
  userProfile: UserProfileFormData,
): Promise<PositionFormData> {
  const [ref, application] = await Promise.all([
    fetchMarketReference().catch(() => ({ industries: [], sectors: [] })),
    privateCircleService.fetchMyApplication().catch(() => null),
  ]);
  const source = buildPositionPrefillSource(userProfile, application);
  return finalizePositionFormForSubmit(
    prefillPositionFromProfileSource(normalizePositionFormData(form), source, ref),
  );
}
